type props = {
  classWrap?: string
  className?: string
  id: string
  name?: string
  label: string
  placeholder?: string
  autocomplete?: string
  required?: boolean
  value?: string
  onInput?: any
}

export function TextAreaInput({ classWrap, className = 'w-full h-[146px]', id, name, label, placeholder, autocomplete, required, value, onInput }: props) {
  return (
    <div className={`input-wrap ${classWrap}`}>
      <textarea
        className={`input peer no-autocomplete ${className}`}
        id={id}
        name={name}
        aria-label={label}
        placeholder={placeholder}
        autoComplete={autocomplete}
        required={required}
        value={value}
        onInput={onInput}
      />
      <label className="input-label textarea-input" htmlFor={id}>
        {placeholder} {required && '*'}
      </label>
    </div>
  )
}
